import styled, { keyframes } from 'styled-components';
import * as Icon from 'react-feather';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const SpinningLoaderIcon = styled(Icon.Loader)`
  animation: ${spin} 1.5s linear infinite;
  transform-origin: center;
  display: inline-block;
`;
